import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class EcomerceService {
  baseUrl = environment.baseUrl;
  empresas: any;

  constructor(private http: HttpClient, private toastrService: ToastrService) {}

  loginUsuarioEcomerce(data: any) {
    return this.http.post<any>(
      `${this.baseUrl}api/Ecomerce/loginUsuarioEcomerce`,
      data
    );
  }

  resetarSenha(loginCPF: any): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/Ecomerce/resetarSenha?loginCPF=${loginCPF}`
    );
  }

  salvarUsuarioEcomerce(data: any) {
    return this.http.post<any>(
      `${this.baseUrl}api/Ecomerce/salvarUsuarioEcomerce`,
      data
    );
  }

  salvarClienteEcomerce(data: any) {
    return this.http.post<any>(
      `${this.baseUrl}api/Ecomerce/salvarClienteEcomerce`,
      data
    );
  }

  salvarPedido(data: any) {
    return this.http.post<any>(
      `${this.baseUrl}api/Ecomerce/salvarPedido`,
      data
    );
  }

  salvarComentarioNoBlog(comment: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}api/ecomerce/salvarComentarioNoBlog`,
      comment
    );
  }

  listarProdutos(cidade: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/Ecomerce/listarProduto?cidade=${cidade}`
    );
  }

  obterProdutoLinkDireto(idProduto: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/Ecomerce/obterProdutoLinkDireto?idProduto=${idProduto}`
    );
  }

  obterProdutoPorId(idProduto: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/Produto/obter?idProduto=${idProduto}`
    );
  }

  listarPedidoPorCpf(cpfCnpj: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/Ecomerce/listarPedidoPorCpf?CpfCnpj=${cpfCnpj}`
    );
  }

  detalharPedidoPorIdPedido(idPedido: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/Ecomerce/detalharPedidoPorIdPedido?IdPedido=${idPedido}`
    );
  }

  obterPedidoPorIdPedido(idPedido: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/Ecomerce/obterPedidoPorIdPedido?idPedido=${idPedido}`
    );
  }

  listarTransacaoPorIdPedido(idPedido: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/ecomerce/listarTransacaoPorIdPedido?IdPedido=${idPedido}`
    );
  }

  obterUsuarioEcomercePorLoginCPF(loginCPF: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/Ecomerce/obterUsuarioEcomerce?loginCPF=${loginCPF}`
    );
  }

  getEmpresasAPI(cidade: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/ecomerce/listarEmpresas?cidade=${cidade}`
    );
  }

  obterEmpresaPorId(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/ecomerce/obterEmpresaPorId/?id=${id}`
    );
  }

  obterServicosEmpresaPorId(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/ecomerce/obterServicosEmpresaPorId/?id=${id}`
    );
  }

  listar(idEmpresa: any): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/Ecomerce/listarBlogs?idEmpresa=${idEmpresa}`
    );
  }

  obterBlogPorId(idBlog: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/Ecomerce/obterBlogPorId?idBlog=${idBlog}`
    );
  }

  obterBlogComentarios(idBlog: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}api/ecomerce/listarBlogComentario/${idBlog}`
    );
  }

  enviarMSGContato(data: any) {
    return this.http.post<any>(
      `${this.baseUrl}api/Ecomerce/enviarContatoSite`,
      data
    );
  }

  enviarNewsLetter(data: any) {
    return this.http.post<any>(
      `${this.baseUrl}api/Ecomerce/enviarNewsLetter`,
      data
    );
  }

  listarCidades() {
    return this.http.get<any>(`${this.baseUrl}api/ecomerce/listarCidades`);
  }
  
}
